import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  ListSitemapPagesOptions,
  ListSitemapPagesResponse,
  listSitemapPages as universalListSitemapPages,
} from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/seo' };

export function listSitemapPages(
  httpClient: HttpClient
): ListSitemapPagesSignature {
  return (options?: ListSitemapPagesOptions) =>
    universalListSitemapPages(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListSitemapPagesSignature {
  /**
   * Lists sitemap pages for a given item type with optional pagination
   * @returns Response message for getting sitemap pages
   */
  (options?: ListSitemapPagesOptions): Promise<
    NonNullablePaths<
      ListSitemapPagesResponse,
      | `pages`
      | `pages.${number}._id`
      | `pages.${number}.shouldBeIncludedInSitemap`
      | `pages.${number}._updatedDate`,
      4
    >
  >;
}

export {
  CursorPaging,
  Cursors,
  Image,
  ItemType,
  ListSitemapPagesOptions,
  ListSitemapPagesRequest,
  ListSitemapPagesResponse,
  ListStaticSitemapPagesRequest,
  ListStaticSitemapPagesResponse,
  PagingMetadataV2,
  SitemapEntry,
  Video,
} from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';
